import React from 'react'

const Slider0 = ({h2,p1}) => {
  return (
    <div className='head'>
        <h2>{h2}</h2>
        <p>{p1}</p>
    </div>
  )
}

export default Slider0